export default __webpack_public_path__ + "static/cover-big-applozic-0eefde403c6140fae63b9c94a199af3e.png";